import {useState, useEffect, useReducer, useContext} from 'react'
import {useNavigate, Link} from 'react-router-dom'
import { Badge, Box, Button, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";

import { TbReportAnalytics } 		from "react-icons/tb";
import { MdOutlinePaid } 			from "react-icons/md";
import { MdOutlineNewReleases } 	from "react-icons/md";
import ReportIcon 					from '@mui/icons-material/Report';
import CheckCircleIcon 				from '@mui/icons-material/CheckCircle';
import ForumIcon					from '@mui/icons-material/Forum';

import useFetch 					from '../api/api'
import AuthContext 					from '../context/AuthProvider';
import NotificationsIcon 			from '@mui/icons-material/Notifications';
import config from '../common/Config';

let privateFetch

const NotificationMenu = ({ anchorEl, handleClose, open, notifications, handleNotificationsChange }) => {

	privateFetch = useFetch()

	const [,forceUpdate] = useReducer(x => x + 1,0)
	const navigate = useNavigate();

	const markAsRead = (pId) => {
		privateFetch(config.apiUrl +'/api/notifications/read/'+ pId)
	}

	const markAllAsRead = () => {
		privateFetch(config.apiUrl +'/api/notifications/read/'+ notifications.map(n => {
			n.status = 'READ'
			return n.id
		}).join(','))

		handleNotificationsChange(notifications)
		forceUpdate()
	}

	const handleClick = (i) => {
		notifications[i].status = 'READ'
		markAsRead(notifications[i].id)
		handleNotificationsChange(notifications)
		forceUpdate()

		navigate(notifications[i].link);
		navigate(0);
		handleClose();
	}

	if ( notifications === null) {
		return
	}

	const getMenuIcon = (pType) => {
		switch (pType) {
			case 'NEWPOST' : return <ForumIcon size="1.6668em" />; 
			case 'POSTUPDATE' : return <ForumIcon size="1.6668em" />; 
			case 'STOCK' : return <TbReportAnalytics size="1.6668em" />; 
			case 'EARNINGS_BR_NEW' : return <MdOutlineNewReleases size="1.6668em" />; 
			case 'EARNINGS_US_NEW' : return <MdOutlineNewReleases size="1.6668em" />; 
			case 'PAYMENT_SUCCESS' : return <CheckCircleIcon size="1.6668em" sx={{color: 'green'}} />; 
			case 'PAYMENT_FAILURE' : return <ReportIcon size="1.6668em" sx={{color: 'red'}} />; 
			default : return <MdOutlinePaid  size="1.6668em" />
		}
	}

	return (
		<Menu
			id="basic-menu"
			anchorEl={anchorEl}
			open={open}
			onClose={handleClose}
			>
			{notifications.map((item, i) => (
				<MenuItem key={item.id} onClick={() => handleClick(i)} sx={{fontSize: 12, fontWeight: (item.status === 'UNREAD' ? 'bold' : 'normal') }}>
					<ListItemIcon>{getMenuIcon(item.type)}</ListItemIcon>
					<ListItemText disableTypography>{item.message}</ListItemText>

					{ item.imageUrl && item.imageUrl !== '' ? (
					<Box
						component="img"
						sx={{
							backgroundColor : "lightgray",
							borderRadius : 25,
							marginLeft: 2,
							height: 20,
							width: 20,
						}}
						alt="The house from the offer."
						src={item.imageUrl}
						/>
					) : null }
					
				</MenuItem>
			))}
			<Divider/>
			<MenuItem>
				<Button variant='text' sx={{fontSize : 8}} onClick={markAllAsRead} align="left">Marcar todas como lida</Button>
				<Button variant='text' sx={{fontSize : 8}} component={Link} to='/notifications' align="right">Notificações antigas</Button>
			</MenuItem>

		</Menu>
	)
}

const NotificationBell = () => {
	const { auth }							= useContext(AuthContext)

	const [open, setOpen] 					= useState(false);
    const [anchorEl, setAnchorEl] 			= useState(null);
	const [notifications, setNotifications]	= useState()

	const [,forceUpdate] 					= useReducer(x => x + 1,0)
	const privateFetch 						= useFetch();
	const navigate 							= useNavigate();


	useEffect(() => {
		if (!auth.accessToken) return
		privateFetch(config.apiUrl +'/api/notifications')
		.then(data => data.json())
		.then(data => setNotifications(data))
	}, [auth.accessToken])

	useEffect(() => {
		if (!auth.userId) return;

		const eventName = 'notificationFor_' + auth.userId;

		const refetchNotifications = () => {
			privateFetch(config.apiUrl + '/api/notifications')
				.then(d => d.json())
				.then(d => setNotifications(d))
		};

		let visibilityTimer = null;
		const onVisibilityChange = () => {
			if (document.visibilityState !== 'visible') return;
			clearTimeout(visibilityTimer);
			visibilityTimer = setTimeout(refetchNotifications, 3000);
		};
		document.addEventListener('visibilitychange', onVisibilityChange);

		if (typeof SharedWorker !== 'undefined') {
			// SharedWorker: uma única conexão SSE compartilhada entre todas as abas
			const worker = new SharedWorker('/sseWorker.js');
			const port = worker.port;
			port.start();
			port.postMessage({ type: 'init', apiUrl: config.apiUrl });
			port.postMessage({ type: 'subscribe', eventName });

			port.onmessage = ({ data: msg }) => {
				if (msg.type === 'event' && msg.eventName === eventName) {
					setNotifications(prev => [...prev, JSON.parse(msg.data)]);
				}
				if (msg.type === 'connected') {
					refetchNotifications();
				}
			};

			return () => {
				clearTimeout(visibilityTimer);
				document.removeEventListener('visibilitychange', onVisibilityChange);
				port.postMessage({ type: 'disconnect' });
				port.close();
			};
		} else {
			// Fallback para Safari < 16 e browsers sem suporte a SharedWorker
			let eventSource;
			let reconnectTimer;
			let heartbeatTimer;

			const connect = () => {
				eventSource = new EventSource(config.apiUrl + '/sse', { withCredentials: true });

				heartbeatTimer = setTimeout(() => { eventSource.close(); connect(); }, 70 * 60 * 1000);

				eventSource.addEventListener('heartbeat', () => {
					clearTimeout(heartbeatTimer);
					heartbeatTimer = setTimeout(() => { eventSource.close(); connect(); }, 70 * 60 * 1000);
				});

				eventSource.addEventListener(eventName, (e) => {
					setNotifications(prev => [...prev, JSON.parse(e.data)]);
				});

				eventSource.onopen = () => refetchNotifications();

				eventSource.onerror = () => {
					clearTimeout(heartbeatTimer);
					eventSource.close();
					reconnectTimer = setTimeout(connect, 5000);
				};
			};

			connect();

			return () => {
				clearTimeout(visibilityTimer);
				clearTimeout(reconnectTimer);
				clearTimeout(heartbeatTimer);
				document.removeEventListener('visibilitychange', onVisibilityChange);
				if (eventSource) eventSource.close();
			};
		}
	}, [auth.userId])

	if ( notifications === undefined) {
		return
	}

    const newNotifications = `Você tem ${notifications.filter(n => n.status === 'UNREAD').length} novas notificações!`;
    const noNotifications = 'Sem novas notificações';

	const handleNotificationsChange = (notifications) => {
		setNotifications(notifications)
		forceUpdate()
	}

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget)
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title={notifications.filter(n => n.status === 'UNREAD').length > 0 ? newNotifications : noNotifications}>
                <IconButton
                    onClick={notifications.length ? handleOpen : () => navigate('/notifications')}
                    anchorel={anchorEl}
	                >
                    <Badge
                        badgeContent={notifications.filter(n => n.status === 'UNREAD')?.length}
    	    			color="error"
        	            >
                        <NotificationsIcon style={{ color: 'white' }}/>
                    </Badge>
                </IconButton>
            </Tooltip>
            <NotificationMenu
                open={open}
                anchorEl={anchorEl}
                handleClose={handleClose}
                notifications={notifications}
				handleNotificationsChange={handleNotificationsChange}
            />
        </div>
    )
}

export default NotificationBell